"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getLocationTo = () => {
    //   return window.location.pathname.includes("list") &&
    //     !window.location.pathname.includes("map")
    //     ? "list"
    //     : "search";
    return "list";
};
exports.default = getLocationTo;
